<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="promocodes-loader">
    <div class="card wavebg !tw-w-full">
      <div class="!tw-flex pc-header !tw-justify-between">
        <div class="header-left">
          <!-- <div class="!tw-flex !tw-items-center">
              <label class="mb-0">Period</label>
              <div class="empty-select ml-8 mr-8">Not Specified</div>
            </div> -->
          <div class="form-group mt-0 mb-0">
            <input placeholder="Search..." class="form-control mt-0 mr-8" type="text">
          </div>
        </div>
        <div class="header-right">
          <div class="!tw-flex justyfy-content-end ">
            <button class="btn btn-outline-primary btn-sm mr-0 ml-0">
              Refresh
            </button>
            <button class="btn btn-primary btn-sm ml-8">
              + Add Promocode
            </button>
          </div>
          <div class="empty-pagination ml-8" style="width: 269px">
            <div class="empty-select mr-8" style="width: 80px">
              100
            </div>
            <span>&lt; &lt;&lt; Page</span>
            <div class="form-group mb-0 mt-0">
              <input placeholder="1" class="form-control mt-0 pl-16 pr-16" style="width: 40px">
            </div>
            <span>of 2 > >></span>
          </div>
        </div>
      </div>
      <div class="filter-search pb-24">
        Filter & Search
      </div>
      <div class="table-empty mt-16 mb-8">
        <div class="table-empty__head">
          <!-- <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Actions</div> -->
        </div>
        <div class="table-empty__body">
          <!-- <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div> -->
        </div>
        <div class="mob-table__block mob-table__block-actions pt-0">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss">
.promocodes-loader{
  overflow: hidden;
  .header-left, .header-right{
    display: flex;
  }
  .filter-search{
    display: none;
  }
  @media (max-width: 1200px){
    .header-right{
      flex-direction: column;
      align-items: flex-end;
      >div:first-child{
        margin-bottom: 10px;
      }
    }
    .header-left{
      align-items: center;
    }
  }
  @media (max-width: 650px){
    .filter-search{
      display: block;
      border-bottom: 1px solid #e7ecf1;
    }
    .pc-header{
      display: none !important;
    }
  }
}


</style>
